var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreedotsOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 4,
    viewBox: "0 0 16 4",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.864 0.855469C14.544 0.855469 14.272 0.967469 14.048 1.19147C13.824 1.41547 13.712 1.68747 13.712 2.00747C13.712 2.3168 13.824 2.58347 14.048 2.80747C14.272 3.0208 14.5387 3.12747 14.848 3.12747C15.168 3.12747 15.44 3.0208 15.664 2.80747C15.888 2.58347 16 2.3168 16 2.00747C16 1.68747 15.888 1.41547 15.664 1.19147C15.44 0.967469 15.1733 0.855469 14.864 0.855469ZM1.136 0.855469C0.826667 0.855469 0.56 0.967469 0.336 1.19147C0.112 1.41547 0 1.68747 0 2.00747C0 2.3168 0.112 2.58347 0.336 2.80747C0.56 3.03147 0.826667 3.14347 1.136 3.14347C1.456 3.14347 1.728 3.03147 1.952 2.80747C2.176 2.58347 2.288 2.3168 2.288 2.00747C2.288 1.68747 2.176 1.41547 1.952 1.19147C1.728 0.967469 1.456 0.855469 1.136 0.855469ZM8 0.855469C7.69067 0.855469 7.424 0.967469 7.2 1.19147C6.976 1.41547 6.864 1.68747 6.864 2.00747C6.864 2.3168 6.976 2.58347 7.2 2.80747C7.424 3.0208 7.69067 3.12747 8 3.12747C8.32 3.12747 8.58667 3.0208 8.8 2.80747C9.024 2.58347 9.136 2.3168 9.136 2.00747C9.136 1.68747 9.024 1.41547 8.8 1.19147C8.58667 0.967469 8.32 0.855469 8 0.855469Z",
    fill: "#E56800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreedotsOrange);
export default __webpack_public_path__ + "static/media/threedotsOrange.91220ffcb9ee1d833346d3975b0b9e2d.svg";
export { ForwardRef as ReactComponent };